/* BUTTON IN THE NAVIGATIONO BAR */
import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "../styled";
import { CircularProgress, Fade } from "@material-ui/core";
import { theme } from "../theme";

const ButtonSubmit = styled(Button)((buttonType) => ({
	textAlign: "center",
	fontSize: 16,
	maxHeight: 50,
	minWidth: 250,
	maxWidth: 400,
	borderRadius: 20,
	color: "#4DAC27",
	borderColor: "#4DAC27",
	backgroundColor: "#FFF",
	boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `,
	border: "1px solid",
	"& .MuiButton-label": {
		fontFamily: "Montserrat, sans-serif !important",
		fontWeight: "bold",
	},
}));
const StyledCircularProgress = styled(CircularProgress)({
	width: 20,
	color: "#31ccad",
});

const variants = {
	column: {
		marginTop: 3,
	},
	row: {
		marginRight: "3%",
	},
	listButton: {
		minWidth: "100%",
	},
};

const SpLoadingButton = ({ text, type, loading, onClick, buttonType, variant, disabled, style }) => {
	return !loading ? (
		<ButtonSubmit disabled={disabled} type={type} style={{ ...style, ...variants[variant], marginRight: !variant && "3%", backgroundColor: "#FFF" }} onClick={onClick} color='primary' disableElevation>
			{text}
		</ButtonSubmit>
	) : (
		<Fade
			in={loading}
			style={{
				display: "flex",
				width: "100%",
				justifyContent: "center",
				transitionDelay: loading ? "800ms" : "0ms",
			}}
			unmountOnExit
		>
			<StyledCircularProgress />
		</Fade>
	);
};

export default SpLoadingButton;
